__turbopack_context__.v({
  "link": "nav-resource-links-module__G-I8HG__link",
  "list": "nav-resource-links-module__G-I8HG__list",
});
